import { Routes, Route, Navigate } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import AuthenticatedLayout from "../layouts/AuthenticatedLayout";
import BlankLayout from "../layouts/BlankLayout";
import Login from "../pages/Authentication/Login";
import Dashboard from "../pages/Dashboard";
import ReportPage from "../pages/Reports/ReportPage";
import VaultAccess from "../pages/VaultAccess/VaultAccess";
import ProductDetail from "../pages/VaultAccess/VaultAccessDetail";
//import VaultAccessDetail from "../pages/VaultAccess/VaultAccessDetail";
import Error404 from "../pages/Common/Error404";
import ProtectedRoute from "./ProtectedRoute";

import PageTransition from "../components/Common/PageTransition";

export default function AppRoutes() {
    return (
        <Routes>

            {/* ROOT */}
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* BEFORE LOGIN */}
            <Route element={<AuthLayout />}>
                <Route
                    path="/login"
                    element={
                        <PageTransition>
                            <Login />
                        </PageTransition>
                    }
                />
            </Route>

            {/* AFTER LOGIN */}
            <Route element={<ProtectedRoute />}>
                <Route element={<AuthenticatedLayout />}>

                    <Route
                        path="/dashboard"
                        element={
                            <PageTransition>
                                <Dashboard />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/report"
                        element={
                            <PageTransition>
                                <ReportPage />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/vaultaccess"
                        element={
                            <PageTransition>
                                <VaultAccess />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/product-detail/:style_ID"
                        element={
                            <PageTransition>
                                <ProductDetail />
                            </PageTransition>
                        }
                    />
                </Route>
            </Route>

            {/* FALLBACK */}
            <Route element={<BlankLayout />}>
                <Route
                    path="*"
                    element={
                        <PageTransition>
                            <Error404 />
                        </PageTransition>
                    }
                />
            </Route>

        </Routes>
    );
}